import { render, staticRenderFns } from "./InventoryCoaCheck.vue?vue&type=template&id=5216b93e"
import script from "./InventoryCoaCheck.vue?vue&type=script&lang=js"
export * from "./InventoryCoaCheck.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5216b93e')) {
      api.createRecord('5216b93e', component.options)
    } else {
      api.reload('5216b93e', component.options)
    }
    module.hot.accept("./InventoryCoaCheck.vue?vue&type=template&id=5216b93e", function () {
      api.rerender('5216b93e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inventoryLabResult/InventoryCoaCheck.vue"
export default component.exports